// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Content":"Content-3e8macn55h5nut94v68y7f4vf8w1yteu4ss41zfnm841knmp2yr4fbuvngebs6w6gx3zvd976wd8cbrbu1ztk19sup7tckw17pxvt3","loading":"loading-3hthrks4htxwvayuhk9ey3dg5saffkr5kj1mdphbzjevke2642g9y2wbqdukjfqzry7ux1js1chrjrxjkngtj22rfw9y4m8sgp21yhm","pulse":"pulse-eartgfbzmaup7vs7xpktqmrhk5ueux2sqe1f136g32pr4x3626hxnsfzw56kjmbwy6vq4mrkp2xq23dp2m2up423ht88jebp1x897b"};


//////////////////
// WEBPACK FOOTER
// ./src/views/InformationClause/InformationClause.module.scss
// module id = 1731
// module chunks = 0